<template>
<section id="register">
    <h1>Admin Registration</h1><Br/>    
    <img src="@/assets/img/logo.png" />
    <form @submit="onSubmit">
        <b-input type="text" name="fullname" v-model="input.name" placeholder="Full Name"></b-input><br/>
        <b-input type="email" name="email" v-model="input.email" placeholder="E-mail"></b-input><br/>
        <b-input type="password" name="password" v-model="input.password" placeholder="Password"></b-input><br/>        
        <b-select id="country" name="country" v-model="input.country" @input="listSchools()">
            <option selected value="my">Malaysia</option>
            <option value="id">Indonesia</option>
        </b-select><br/>
        <b-select id="schoolID" name="schoolID" v-model="input.schoolID">
            <option selected value="0">Select the school</option>
            <option v-for="school in schools" v-bind:value="school._id" v-bind:key="school._id">{{ school.name }}</option>
        </b-select><br/>
        <!-- <b-field label=""
            type="is-warning"
            message="Please enter a valid email">
            <b-input type="email" name="email" v-model="input.email" placeholder="E-mail"></b-input>
        </b-field> -->
        <b-input type="password" name="authenticate" v-model="input.authenticate" placeholder="Authenticate"></b-input><br/>
        <button type="submit" class="button is-primary is-fullwidth">Register</button>
         <b-field :message="result"
            type="is-success"
            name="result"
            >
        </b-field>
        <b-field :message="errors"
            type="is-danger"
            name="errors"
            >
            <!--<button type="button" v-on:click="login()" class="button">Login</button>-->
        </b-field>        
        <button v-on:click="goLogin()" class="button is-fullwidth">Admin Login</button>
    </form>
</section>
</template>

<script>

    import axios from 'axios'

    export default {
        name: 'register',
        data () {            
            return {
                input: {
                    name: "",
                    email: "",
                    password: "",
                    schoolID: '0',
                    staffID: "",
                    authenticate: "",
                    country: "my"
                },
                schools: [],
                result : "",
                errors: []
            }
        },
        created() {
        },        
        mounted(){
            this.listSchools()
        },
        methods: {
            listSchools(){ 
                console.log("69 calling listSchools")
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/public/school/list', {
                        params: {
                            country: this.input.country
                        }
                    })
                .then(response => {
                // JSON responses are automatically parsed.
                    this.schools = response.data
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            goLogin() {
                this.$router.push({
                    name: "Login"
                });
            },
            onSubmit (evt) {
                evt.preventDefault()
                if(this.input.name != "" && this.input.email != "" && this.input.password != "" && this.input.schoolID != "0") {

                    this.input.staffID = this.input.email
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.MY_URL + '/api/auth/admin/register', this.input)
                    .then(response => {
                        if (response.data.success == true){                            
                            console.log("Admin added!")
                            this.result = "Admin addded!"
                            this.input.name = ""
                            this.input.email = ""
                            this.input.password = ""
                            this.input.schoolID = ""
                            this.input.authenticate = ""
                            this.errors = []
                        }else{
                            console.log(response.data.msg)
                            this.errors.push(response.data.msg)
                        }

                        // this.$router.push({
                        //     name: 'secure'
                        // })
                    })
                    .catch(e => {
                        console.log(e.response)
                        this.errors.push(e)
                    })
                    
                } else {
                    this.errors.push("Please enter all the required details.")
                    console.log("Please enter all the required details.")
                }
            }
        }
    }
</script>

<style scoped>
#register {
    width: 500px;
    border: 1px solid #CCCCCC;
    background-color: #FFFFFF;
    margin: auto;
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/School/AddAdmin.vue